import { render, staticRenderFns } from "./heart-beat.vue?vue&type=template&id=79a84751&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "heart-beat.vue"
export default component.exports